/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-31 17:18:39
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-03 18:20:50
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelCategory/Components/Header/index.tsx
 */
import React from 'react';
import css from './css.module.less';
import { Icon } from '@/src/tools/icon';
import { instanceType, AllTypes } from 'src/tools/helper';

const Header = (props) => {
  const { title, productsAmount, url, subTitle } = props;
  const isNumber = instanceType(productsAmount) == AllTypes.Number;
  return (
    <div className={css.container}>
      <div className={css.titlePart}>
        <div className={css.titleContainer}>
          {title}
          {isNumber && (
            <React.Fragment>
              {' '}
              <Icon type='iconproducts' className={css.icon} />
              <span className={css.amountContainer}>{productsAmount || 0}</span>
            </React.Fragment>
          )}
        </div>
        {subTitle && <div className={css.subTitleContainer}>{subTitle}</div>}
      </div>
      <div className={css.urlPart}>{url}</div>
    </div>
  );
};
export default Header;
